import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 20px;
  padding-top: 80px;
  background-color: #17224d;
`;

export const FooterBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  max-width: 1200px;
  color: white;
  gap: 20px;

  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const FooterBoxSection = styled.div`
  flex: 1;
  min-width: 150px;
  display: flex;
  gap: 15px;
  flex-direction: column;

  /* Ensure the first section takes up 100% of the width above 1100px */
  &:first-child {
    flex: 100%; /* Makes the first section take up 100% width */
    align-items: center;
  }

  @media (max-width: 1100px) {
    flex: none; /* Reset for small screens */
  }
`;

export const FooterBoxSectionImage = styled.img`
  width: 40%;
`;

export const FooterBoxBottom = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  color: white;
  font-size: 12px;

  @media (max-width: 700px) {
    flex-direction: column;
    gap: 20px;
  }
`;

export const FooterBoxSectionSlogan = styled.span`
  margin-top: 20px;
  letter-spacing: 2px;
`;

export const FooterBoxSectionSocials = styled.div`
  margin-top: 20px;
`;

export const FooterLine = styled.hr`
  margin-top: 40px;
  opacity: 0.2;
  width: 100%;
  background-color: lightgrey;
  height: 1px;
  border: none;
`;

export const FooterBoxSectionTitle = styled.span`
  font-weight: bold;
`;

export const FooterBoxSectionList = styled.ul`
  list-style: none;
  margin-top: 20px;
  font-size: 13px;
  line-height: 2;
`;

export const FooterBoxSectionListLink = styled.li`
  transition: color 0.3s;
  cursor: pointer;

  &:hover {
    color: #3393f0;
  }
`;

export const FooterBoxSectionListIcon = styled(FontAwesomeIcon)`
  min-width: 40px;
  color: #3393f0;
`;

export const FooterBoxSectionLink = styled.a`
  text-decoration: none;
  color: rgb(38, 131, 224) !important;
`;
